<template>
  <el-dialog
    title="正式发送"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    width="700px"
    @close="close"
  >
    <el-form :model="execform" :label-width="formLabelWidth">
      <!-- <div style="width:630px;line-height:25px;color:red;margin-top:-16px;margin-bottom:20px">
          <div>注意：</div>
          <div>（1）618大促期间短信发送时间：5月30日-6月15日为8:00-22:00，6月16日-6月17日为8:00-次日01:00，6月18日为00:00-23:59:59，6月19日起恢复正常（即9:00-20:00）。</div>
          <div>（2）5月31日-6月18日京东官方短信频控规则:同一商家2天内给同一手机号发送营销短信条数不超过 1 条;每个手机号每 1 天只能收到 9条京东商家短信,每 2 天只能收到 16条京东商家短信。</div>
      </div> -->
      <el-form-item label="执行方式">
        <div class="lineBox">
          <el-radio-group v-model="execform.executionType">
            <el-radio
              v-for="(item, index) in executionTypes"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="执行时间" v-if="execform.executionType === 1">
        <div class="lineBox">
          <el-date-picker
            v-model="execform.timingExecutionTime"
            :editable="false"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="执行周期" v-if="execform.executionType === 2">
        <div class="lineBox">
          <el-radio v-model="execform.cycleExecutionType" :label="0"
            >按天:</el-radio
          >
          <span style="margin-left:10px;">每</span>
          <el-input
            v-model.number="execform.cycleDay"
            style="width: 100px; margin: 0 10px;"
            autocomplete="off"
          ></el-input>
          <span>天</span>
        </div>
        <div class="lineBox">
          <el-radio v-model="execform.cycleExecutionType" :label="1"
            >按周:</el-radio
          >
          <span style="margin-left:10px;display: inline-block;min-width: 32px;"
            >每周</span
          >
          <el-checkbox-group
            v-model="execform.cycleDayWeekly"
            style="margin-left:10px;line-height: 8px;"
          >
            <el-checkbox
              v-for="(item, index) in cycleDayWeeklys"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="lineBox">
          <el-radio v-model="execform.cycleExecutionType" :label="2"
            >按月:</el-radio
          >
          <span style="margin-left:10px;display: inline-block;min-width: 32px;"
            >每月</span
          >
          <el-checkbox-group
            v-model="execform.cycleDayMonthly"
            style="margin-left:10px;text-align: left;line-height: 20px;"
          >
            <el-checkbox
              v-for="(item, index) in cycleDayMonthlys"
              :key="index"
              :label="item"
              >{{ item }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </el-form-item>
      <el-form-item label="执行时间" v-if="execform.executionType === 2">
        <div class="lineBox">
          <el-time-picker
            class="time adjust-style"
            v-model="execform.cycleExecutionTime"
            :editable="false"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            placeholder="具体时间点"
          >
          </el-time-picker>
        </div>
      </el-form-item>
      <el-form-item label="执行范围" v-if="execform.executionType === 2">
        <div class="lineBox">
          <el-date-picker
            v-model="execform.datetime"
            :editable="false"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" @click="execSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
import { getMinWaitTime } from "@/api/intelligentMarket/index"
import {
  getSendTime,
} from "@/api/smsSend";
export default {
  name: "execDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    marketingId: Number,
  },
  data() {
    return {
      // maxLimitDate: '2021-02-25 15:55:23',
      maxLimitDate: '',
      formLabelWidth: "70px",
      execform: {
        id: 0,
        executionType: 0,
        timingExecutionTime: "",
        cycleExecutionType: 0,
        cycleDay: 0,
        cycleDayWeekly: [],
        cycleDayMonthly: [],
        cycleExecutionTime: "00:00:00",
        datetime: [],
        cycleStartTime: "",
        cycleEndTime: "",
      },
      cycleDayWeeklys: [
        {
          value: 2,
          label: "周一",
        },
        {
          value: 3,
          label: "周二",
        },
        {
          value: 4,
          label: "周三",
        },
        {
          value: 5,
          label: "周四",
        },
        {
          value: 6,
          label: "周五",
        },
        {
          value: 7,
          label: "周六",
        },
        {
          value: 1,
          label: "周日",
        },
      ],
      cycleDayMonthlys: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ],
      executionTypes: [
        {
          value: 0,
          label: "立即执行",
        },
        {
          value: 1,
          label: "定时执行",
        },
        {
          value: 2,
          label: "周期执行",
        },
      ],
      defaultTime: Date.now() - 24 * 60 * 60 * 1000,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.defaultTime || time.getTime() > Date.now() + 8.64e7 * 90;
          //  return time.getTime() < Date.now() - 8.64e7;
        },
        selectableRange: "9:00:00 - 19:55:59",
      },
      pickerOptions2: {
        disabledDate: (time) => {
          // return time.getTime() < this.defaultTime;
           return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 8.64e7 * 90;
        },
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
    };
  },
  watch: {
    'execform.timingExecutionTime': {
      handler(newValue, oldValue) {
        if ((newValue && oldValue && (newValue.substring(0, 10) != oldValue.substring(0, 10))) || (newValue && !oldValue)) {
          var val = newValue.substring(0, 10)
          var nowTime10 = this.$getNowDate();
          if (this.maxLimitDate) {
            nowTime10 = this.maxLimitDate; 
          }
          var time1 = nowTime10.substring(0, 10);
          var time2 = nowTime10.substring(11, 19);
          var maxLimit = ''; // 活动节点最小等待时间
          var hmsLimit = ''; // 活动节点最小等待时间时分秒
          
          var startTime = this.limitTime.startTime;
          var endTime = this.limitTime.endTime;

          var arr = time2.split(":");
          var endArr = endTime.split(":");

          // 最晚可以选到时间
          if (arr[0] > endArr[0]) {
            time2 = endTime;
          } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
            time2 = endTime;
          } else if (
            arr[0] == endArr[0] &&
            arr[1] == endArr[1] &&
            arr[2] >= endArr[2]
          ) {
            time2 = endTime;
          }

          if (val == time1) {
            this.execform.timingExecutionTime = val + ' ' + time2;
            this.pickerOptions.selectableRange = time2 + " - " + endTime;
          }
          else {
            // this.execform.timingExecutionTime = val + ' ' + startTime;
            this.pickerOptions.selectableRange = startTime + " - " + endTime;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  mounted() {
    this.limitSendTime();
    this.getLimitTime();
  },
  methods: {
    // 获取活动节点最小等待时间
    getLimitTime() {
      var param = {
        marketingId: this.marketingId
      }
      getMinWaitTime(param).then(res => {
        if (res.code == '1' && res.data) {
          var timeStr = res.data;
          // 限制时间为最小等待时间的半个小时后
          var date = new Date(timeStr);
          date.setMinutes(date.getMinutes() - 40);
          this.maxLimitDate = this.$getNowDate(date);
          this.defaultTime = new Date(this.maxLimitDate.substring(0, 10)).getTime() - 24 * 60 * 60 * 1000;
        }
      })
    },

    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        this.pickerOptions.selectableRange = selectableRange;
      });
    },
    execSubmit() {
      let submit = true;
      let data = JSON.parse(JSON.stringify(this.$data.execform));
      data.id = 0 + this.marketingId;
      if (data.executionType === 1) {
        if (!data.timingExecutionTime) {
          submit = false;
          this.$message.error("请选择执行时间");
        }
      }
      if (data.executionType === 2) {
        if (data.cycleExecutionType === 0) {
          if (!data.cycleDay) {
            submit = false;
            this.$message.error("请输入日期间隔");
          }
          if (!new RegExp("^([1-9]|[1-9]\\d|100)$", "g").test(data.cycleDay)) {
            submit = false;
            this.$message.error("日期间隔天数请输入1-100之间的整数！");
          }
        } else if (data.cycleExecutionType === 1) {
          if (!data.cycleDayWeekly.length) {
            submit = false;
            this.$message.error("请选择执行星期");
          }
        } else if (data.cycleExecutionType === 2) {
          if (!data.cycleDayMonthly.length) {
            submit = false;
            this.$message.error("请选择执行日期");
          }
        }
        if (submit) {
          if (!data.datetime.length) {
            submit = false;
            this.$message.error("请选择执行范围");
          }
        }
      }
      if (submit) {
        data.cycleDayMonthly = data.cycleDayMonthly.join(",");
        data.cycleDayWeekly = data.cycleDayWeekly.join(",");
        data.cycleStartTime = data.datetime[0] || "";
        data.cycleEndTime = data.datetime[1] || "";
        delete data.datetime;
        mnode.execacticity(data).then((response) => {
          if (response.code === 1) {
            this.$message.success(response.message);
            this.viewVisible = false;
            this.$emit("change", 1);
          }else{
            this.$message.error(response.message)
          }
        });
      }
    },
    close() {
      this.viewVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.lineBox .el-checkbox-group .el-checkbox {
  margin-left: 10px;
  margin-right: -1px;
}
/deep/.adjust-style .el-input__inner {
  padding-left: 30px !important;
}
</style>
